import * as types from '../../../lib/actionTypes.es6';

export function getRecentPoliciesRequest(payload) {
  return {
    type: types.GET_RECENT_POLICIES_REQUEST,
    payload: {
      ...payload,
      page: payload.page || 1,
      size: payload.size || 20,
    }
  };
}

export function getRecentPoliciesSuccess(payload) {
  return {
    type: types.GET_RECENT_POLICIES_SUCCESS,
    payload: payload,
  };
}

// A later slice of a progressive (fetchAll) load — appended to what is
// already on screen rather than replacing it.
export function getRecentPoliciesChunk(payload) {
  return {
    type: types.GET_RECENT_POLICIES_CHUNK,
    payload: payload,
  };
}

export function getRecentPoliciesFailure(error) {
  return {
    type: types.GET_RECENT_POLICIES_FAILURE,
    payload: error,
  };
}